var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center"},[_c('div',{staticClass:"p-6 overflow-auto flex flex-col w-full",staticStyle:{"max-width":"550px"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }